import { IconWrapper } from '../IconWrapper';
import { BlogChain as BlogChainIcon } from './svgs/BlogChain';
import { Chainweb as ChainwebIcon } from './svgs/Chainweb';
import { Concepts as ConceptsIcon } from './svgs/Concepts';
import { Contribute as ContributeIcon } from './svgs/Contribute';
import { Gas as GasIcon } from './svgs/Gas';
import { KadenaOverview as KadenaOverviewIcon } from './svgs/KadenaOverview';
import { ManageKda as ManageKdaIcon } from './svgs/ManageKda';
import { Marmalade as MarmaladeIcon } from './svgs/Marmalade';
import { Overview as OverviewIcon } from './svgs/Overview';
import { PactDeveloper as PactDeveloperIcon } from './svgs/PactDeveloper';
import { PactLanguage as PactLanguageIcon } from './svgs/PactLanguage';
import { QuickStart as QuickStartIcon } from './svgs/QuickStart';
import { Receiver as ReceiverIcon } from './svgs/Receiver';
import { ReceiverInactive as ReceiverInactiveIcon } from './svgs/ReceiverInactive';
import { RestApi as RestApiIcon } from './svgs/RestApi';
import { SmartContract as SmartContractIcon } from './svgs/SmartContract';
import { Syntax as SyntaxIcon } from './svgs/Syntax';
import { UsefulTools as UsefulToolsIcon } from './svgs/UsefulTools';
import { Whitepapers as WhitepapersIcon } from './svgs/Whitepapers';
export const BlogChain = IconWrapper(BlogChainIcon);
export const Chainweb = IconWrapper(ChainwebIcon);
export const Concepts = IconWrapper(ConceptsIcon);
export const Contribute = IconWrapper(ContributeIcon);
export const KadenaOverview = IconWrapper(KadenaOverviewIcon);
export const ManageKda = IconWrapper(ManageKdaIcon);
export const Marmalade = IconWrapper(MarmaladeIcon);
export const Overview = IconWrapper(OverviewIcon);
export const PactDeveloper = IconWrapper(PactDeveloperIcon);
export const PactLanguage = IconWrapper(PactLanguageIcon);
export const QuickStart = IconWrapper(QuickStartIcon);
export const RestApi = IconWrapper(RestApiIcon);
export const SmartContract = IconWrapper(SmartContractIcon);
export const Syntax = IconWrapper(SyntaxIcon);
export const UsefulTools = IconWrapper(UsefulToolsIcon);
export const Whitepapers = IconWrapper(WhitepapersIcon);
export const Gas = IconWrapper(GasIcon);
export const Receiver = IconWrapper(ReceiverIcon);
export const ReceiverInactive = IconWrapper(ReceiverInactiveIcon);
//# sourceMappingURL=ProductIcon.js.map